import {
  LOGGER_ARR_SIZE,
  LOGGER_PUSH_TIME,
  SERVICE_NAME,
  URL
} from './constants';
import { BaseLoggerClass } from './baseLogger';
import { LogLevel, type Message } from './type';

export class LoggerClass extends BaseLoggerClass {
  private constructor({
    size = LOGGER_ARR_SIZE,
    time = LOGGER_PUSH_TIME,
    url = URL,
    service = SERVICE_NAME
  }: {
    size?: number;
    time?: number;
    url?: string;
    service?: string;
  }) {
    super(size, time, url, service);
  }

  private static instance: LoggerClass | null = null;

  public static getInstance({
    size,
    time,
    url
  }: {
    size?: number;
    time?: number;
    url?: string;
  } = {}): LoggerClass {
    if (LoggerClass.instance === null) {
      LoggerClass.instance = new LoggerClass({ size, time, url });
    }
    return LoggerClass.instance;
  }

  public error(error: Message, immediatePush: boolean = false) {
    if (process.env.NEXT_PUBLIC_ENV_NAME === 'local') {
      console.error({ ...error, level: LogLevel.ERROR }, immediatePush);
    } else {
      this.push({ ...error, level: LogLevel.ERROR }, immediatePush);
    }
  }

  public info(data: Message, immediatePush: boolean = false) {
    if (process.env.NEXT_PUBLIC_ENV_NAME === 'local') {
      console.info({ ...data, level: LogLevel.INFO }, immediatePush);
    } else {
      this.push({ ...data, level: LogLevel.INFO }, immediatePush);
    }
  }

  public warn(data: Message, immediatePush: boolean = false) {
    if (process.env.NEXT_PUBLIC_ENV_NAME === 'local') {
      console.warn({ ...data, level: LogLevel.WARNING }, immediatePush);
    } else {
      this.push({ ...data, level: LogLevel.WARNING }, immediatePush);
    }
  }

  public log(data: Message, immediatePush: boolean = false) {
    if (process.env.NEXT_PUBLIC_ENV_NAME === 'local') {
      console.log({ ...data, level: LogLevel.LOG }, immediatePush);
    } else {
      this.push({ ...data, level: LogLevel.LOG }, immediatePush);
    }
  }

  public debug(data: Message, immediatePush: boolean = false) {
    if (process.env.NEXT_PUBLIC_ENV_NAME === 'local') {
      console.debug({ ...data, level: LogLevel.DEBUG }, immediatePush);
    } else {
      this.push({ ...data, level: LogLevel.DEBUG }, immediatePush);
    }
  }
}

const logger = LoggerClass.getInstance({});

export { logger };
